import { render } from "./ResultCard.vue?vue&type=template&id=02d42a24&scoped=true&ts=true"
import script from "./ResultCard.vue?vue&type=script&lang=ts"
export * from "./ResultCard.vue?vue&type=script&lang=ts"

import "./ResultCard.vue?vue&type=style&index=0&id=02d42a24&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d42a24"]])

export default __exports__